/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SetupTaskAssignee,
  SetupTaskAssignee$inboundSchema,
} from "./setuptaskassignee.js";

/**
 * Effective task status.
 */
export const SetupTaskStatus = {
  Todo: "todo",
  InProgress: "in_progress",
  AwaitingSupport: "awaiting_support",
  Done: "done",
} as const;
/**
 * Effective task status.
 */
export type SetupTaskStatus = OpenEnum<typeof SetupTaskStatus>;

export type SetupTask = {
  assignee?: SetupTaskAssignee | undefined;
  /**
   * Incomplete prerequisite task keys.
   */
  blockedBy: Array<string>;
  /**
   * Whether current organization facts force the effective status to done. This field is read-only.
   */
  completedByFact: boolean;
  /**
   * Task description.
   */
  description: string;
  /**
   * True for a group that nests cards. A group has no card of its own: it is hidden when every card under it is, done when every visible card is, and cannot be assigned or marked by hand.
   */
  group: boolean;
  /**
   * Whether a platform administrator hid the task.
   */
  hidden: boolean;
  /**
   * Stable code-owned task key.
   */
  key: string;
  /**
   * Key of the group this card sits under. Absent for a top-level card or a group.
   */
  parentKey?: string | undefined;
  /**
   * Effective task status.
   */
  status: SetupTaskStatus;
  /**
   * Task title.
   */
  title: string;
};

/** @internal */
export const SetupTaskStatus$inboundSchema: z.ZodMiniType<
  SetupTaskStatus,
  unknown
> = openEnums.inboundSchema(SetupTaskStatus);

/** @internal */
export const SetupTask$inboundSchema: z.ZodMiniType<SetupTask, unknown> = z
  .pipe(
    z.object({
      assignee: z.optional(SetupTaskAssignee$inboundSchema),
      blocked_by: z.array(z.string()),
      completed_by_fact: z.boolean(),
      description: z.string(),
      group: z.boolean(),
      hidden: z.boolean(),
      key: z.string(),
      parent_key: z.optional(z.string()),
      status: SetupTaskStatus$inboundSchema,
      title: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "blocked_by": "blockedBy",
        "completed_by_fact": "completedByFact",
        "parent_key": "parentKey",
      });
    }),
  );

export function setupTaskFromJSON(
  jsonString: string,
): SafeParseResult<SetupTask, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SetupTask$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SetupTask' from JSON`,
  );
}
